import React, { useEffect, useState } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import AssessmentResponse, {
  AssessmentDetails,
} from "../features/recommendation/textRecommendation/data/response/AssesResponse";
import CommonUtils from "../utils/Common_Utils";
import { LocalStorage } from "../utils/Utils";
import assesClient from "../features/recommendation/textRecommendation/data/api/AssesNameClient";
import { useApi } from "../service/ApiContext";
import { useCommonQueryHook } from "../hook/use_QueryHook";
import strings from "../utils/Strings";
import "../features/recommendation/textRecommendation/styles/textRecommandationStyle.css";
import DropdownArrow from "../assets/images/dashboard/downArrow.png";
interface AssessmentDropdownProps {
  onChange: (value: any) => void;
  title?: String;
  intitalAssessmentId?: string | null | undefined; // For Curriculum Assesment Result
  isTimeStampNotNeed?: boolean;
}

const AssessmentCommonDropdown: React.FC<AssessmentDropdownProps> = ({
  onChange,
  title,
  intitalAssessmentId,
  isTimeStampNotNeed = false,
}) => {
  const api = useApi();
  const fetchAssessmentsApi = async (): Promise<AssessmentResponse> => {
    const param = {
      offset_time: CommonUtils.formatLocalTime(),
      domain_name:
        title === "Jozuna Skills Performance"
          ? "Jozuna"
          : title === "Curriculum Performance"
            ? "Curriculum"
            : "",
    };
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const response = await api.get<AssessmentResponse>(
      assesClient.assesUrl,
      param,
    );
    return response.data;
  };
  const { refetch, data, isLoading, isError } = useCommonQueryHook({
    queryKey: [strings.query_key.assessmentDropdownList, title],
    fetchData: fetchAssessmentsApi,
    onSuccessCallback: async (value) => {
      if (!value?.assessment_names || value.assessment_names.length === 0) {
        return;
      }

      let selectedAssessment;

      // ✅ Try to find matching assessment_id
      if (
        intitalAssessmentId &&
        (
          title === "Curriculum Performance" ||
          title === "Jozuna Skills Performance" ||
          title === "Program Performance"
        )
      ) {
        selectedAssessment = value.assessment_names.find(
          (item) => item.assessment_id === intitalAssessmentId,
        );
      }

      // ✅ Fallback to first item if not found
      if (!selectedAssessment) {
        selectedAssessment = value.assessment_names[0];
      }

      onChange(selectedAssessment);
      setSelectedAssessmentId(selectedAssessment.assessment_id);
      // if (value?.assessment_names && value.assessment_names.length !== 0) {
      //   const firstAssessment = value.assessment_names[0];
      //   onChange(firstAssessment);
      //   setSelectedAssessmentId(firstAssessment.assessment_id);
      // }
    },
  });
  useEffect(() => {
    refetch();
  }, [title]);
  // const [selectedAssessmentId, setSelectedAssessmentId] = useState<string>(
  //   title === "Curriculum Performance" && intitalAssessmentId
  //     ? intitalAssessmentId
  //     : data?.assessment_names && data?.assessment_names?.length !== 0
  //       ? data?.assessment_names[0].assessment_id || ""
  //       : "",
  // );
  const [selectedAssessmentId, setSelectedAssessmentId] = useState<string>(
    (
      title === "Curriculum Performance" ||
      title === "Jozuna Skills Performance" ||
      title === "Program Performance"
    ) && intitalAssessmentId
      ? intitalAssessmentId
      : data?.assessment_names &&
        data?.assessment_names?.length !== 0
        ? data?.assessment_names[0].assessment_id || ""
        : "",
  );
  // if (!data || data.assessment_names.length === 0) {
  //   return null;
  // }
  return (
    <div
      className="ex-drop-container-dashboard"
      style={{
        paddingLeft: "20px",
      }}
    >
      <FormControl
        fullWidth
        className="custom-select-dashboard"
        style={{ paddingRight: "0" }}
      >
        <Select
          labelId="assessment-select-label"
          value={selectedAssessmentId}
          onChange={(event) => {
            const selectedId = event.target.value;
            const selectedAssessment = data?.assessment_names.find(
              (assessment) => assessment.assessment_id === selectedId,
            );

            if (selectedAssessment) {
              onChange(selectedAssessment);
              setSelectedAssessmentId(selectedAssessment.assessment_id);
            }
          }}
          displayEmpty
          IconComponent={() => (
            <div
              style={{
                backgroundColor: "#ECEFF3",
                height: "45px",
                width: "35px",
                borderRadius: "0 8px 8px 0",
                pointerEvents: "none",
              }}
              className="custom-arrow-dashboard"
            >
              <img
                src={DropdownArrow}
                alt="Dropdown arrow"
                className="custom-arrow-dashboardIcon"
              />
            </div>
          )}
          MenuProps={{
            PaperProps: {
              className: "custom-menu",
              style: {
                borderRadius: "8px",
              },
            },
          }}
        >
          {data?.assessment_names?.length ? (
            data.assessment_names.map((assessment) => (
              <MenuItem
                key={assessment.assessment_id}
                value={assessment.assessment_id}
              >
                <div className="assessment-content">
                  <span className="assessment-name">
                    {assessment.assessment_name}
                  </span>

                  {isTimeStampNotNeed !== true && (
                    <>
                      <span>|</span>
                      <span className="assessment-timestamp">
                        {assessment.timestamp}
                      </span>
                    </>
                  )}
                </div>
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>
              <span
                style={{
                  color: "#8A8A8A",
                  fontSize: "14px",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                No Data Found
              </span>
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </div>
  );
};

export default AssessmentCommonDropdown;
